export enum InfoMesssages {
  refundManualPaymentDisabledMessage = 'Refund is not allowed for manual payments.',
  refundAlreadyProcessedDisabledMessage = 'Refund is already initiated/processed.',
  refundNoPermissionMessage = 'You do not have permission to issue refund.',
  refundCheckDepositDisabledMessage = 'Refund is not allowed for check deposit payments.',
  shareReceiptNoPermissionMessage = 'You do not have permission to share the receipt.',
  shareInvoiceNoPermissionMessage = 'You do not have permission to share the invoice.',
  editInvoiceNoPermissionMessage = 'You do not have permission to edit an invoice.',
  createInvoiceNoPermissionMessage = 'You do not have permission to create an invoice.',
  createCustomerNoPermissionMessage = 'You do not have permission to create a customer',
  createJobNoPermissionMessage = 'You do not have permission to create a job',
  editJobNoPermissionMessage = 'You do not have permission to edit a job',
  editDoneJobNoPermissionMessage = 'You do not have permission to edit a job that is done',
  cannotEditJobUnderPR = 'This job cannot be edited because it has been approved for assigned members in a pay run',
  createTagNoPermissionMessage = 'You do not have permission to create a tag',
  createExternalCompanyNoPermissionMessage = 'You do not have permission to create an external company',
  editCustomerNoPermissionMessage = 'You do not have permission to edit a customer.',
  noInvoicesToExport = 'No invoices to export',
  noReceiptsToExport = 'No receipts to export',
  noPayoutsToExport = 'No payouts to export',
  noDisputesToExport = 'No disputes to export',
  noJobsToExport = 'No jobs to export',
  inviteTeamMemberNoPermissionMessage = 'You do not have permission to invite team member.',
  editTeamMemberPermissionMessage = 'You do not have permission to edit team member.',
  createItemNoPermissionMessage = 'You do not have permission to create item',
  noItemsToExport = 'No items to export',
  noServiceChargesToExport = 'No service charges to export',
  createCategoriesNoPermissionMessage = 'You do not have permission to create category',
  createTaxesNoPermissionMessage = 'You do not have permission to create tax',
  createServiceChargesNoPermissionMessage = 'You do not have permission to create service charge',
  genericNoPermissionMessage = 'You do not have permission to perform this action',
  noServiceAddressMessageForJob = 'You cannot create an job from a paid invoice for a customer without service address',
  noServiceAddressMessageForEstimate = `You cannot create an estimate from a 
paid invoice for a customer without service address`,
  noJobForRejectedEstimate = 'You cannot create a job from a rejected estimate',
  noInvoiceForRejectedEstimate = 'You cannot create an invoice from a rejected estimate',
  noEstimatesToExport = 'No estimates to export',
  noPermissionToCreatePayRules = 'You do not have permission to create pay rules',
  noPermissionToEditPaySchedule = 'You do not have permission to edit pay schedule',
  noPermissionToApproveAndProcessAccounting = 'You do not have permission to approve and process accounting',
  noPermissionToAddServiceAreas = 'You do not have permission to add service areas',
  noPermissionToManageFSMPlan = 'You do not have permission to manage Field Serve subscription'
}
